import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse } from "@/lib/types/APIResponse";
import { type PublisherApp } from "@/lib/types/Firm";
import { baseFastApiFirmRoute } from "./firm";

type SearchPublisherAppsBody = {
  search?: string;
};

export function searchPublisherAppsV2(data: SearchPublisherAppsBody = {}) {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<PublisherApp[]>
    >(`${baseFastApiFirmRoute}/publisher-apps/search`, data)
    .then((res) => res.data);
}
